(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-static-notification', actionFunc);

    function actionFunc(CommonHelper, lodash, $timeout, ActionModel, $rootScope) {
        return function(options, eventData, actionResponse) {
            const appliedOptions = angular.copy(options);
            if (lodash.get(options, 'remote_message', true)) {
                const remote_message = lodash.get(actionResponse, 'display_msg', '');
                if (!CommonHelper.isEmpty(remote_message)) {
                    appliedOptions.message = remote_message;
                }
            }

            ActionModel.set('static-notifier', appliedOptions.name, appliedOptions);
            const delay = lodash.get(appliedOptions, 'delay', null);
            if (!CommonHelper.isEmpty(delay)) {
                $timeout(function() {
                    ActionModel.set('static-notifier', appliedOptions.name, {});
                    $rootScope.$apply();
                }, delay);
            }
        };
    }
})();